import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loanService } from '../../services/loanService';

export const useGetLoanEarningsByFundraisingId = (fundraisingId, groupId) => {
  return useQuery({
    staleTime: 1000 * 60 * 60, // 1 hour,
    enabled: !!groupId,
    queryKey: [
      QUERY_KEYS.loan.loan_earnings_by_fundraising_id,
      fundraisingId,
      groupId,
    ],
    queryFn: () =>
      loanService
        .loanEarningsByFundraisingId(fundraisingId, groupId)
        .then(response => {
          const { status, data } = response;
          if (status === 200) {
            return data;
          }
          throw new Error('Fetch failed');
        }),
  });
};
